import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ForgingProfessionals from "./sections/ForgingProfessionals";
import NuestraIdentidadEducativa from "./sections/NuestraIdentidadEducativa";
import FeaturedCourses from "./sections/FeaturedCourses";
import PresenciaNacional from "./sections/PresenciaNacional";
import Testimonials from "./sections/Testimonials";
import IniciaTuFormacion from "./sections/IniciaTuFormacion";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ForgingProfessionals />
      <NuestraIdentidadEducativa />
      <FeaturedCourses />
      <PresenciaNacional />
      <Testimonials />
      <IniciaTuFormacion />
      <Footer />
    </div>;
}